export default __webpack_public_path__ + "static/media/icon-prompt.ef660305.svg";